/*************************************************/
/* MOBILE MENU                                   */
/*************************************************/

export function mobileMenu() {
  const menuButton = document.querySelector(".mobile-menu-nav");
  const mobileMenu = document.querySelector("#mobile-menu");
  const activeOpenClass = "mobile-menu--open";
  const activeClass = "mobile-menu--active";
  const burgerMenu = document.querySelector(".mobile-menu-nav__btn");
  const body = document.body;

  const toggleBodyScroll = () => {
    body.classList.toggle("no-scroll", mobileMenu.classList.contains(activeOpenClass));
  };

  const showMenu = (menuEl) => menuEl?.classList.add("mobile-menu__sub-menu--active");
  const hideMenu = (menuEl) => menuEl?.classList.remove("mobile-menu__sub-menu--active");

  const addCloseClassToAllSubmenus = () => {
    const submenus = mobileMenu.querySelectorAll(".mobile-menu__sub-menu");
    submenus.forEach((submenu) => {
      submenu.classList.add("mobile-menu__sub-menu--close");
    });
  };

  // Helper: run stagger on a given list (<ul>), using clip-path + opacity
  function runMenuStagger(list) {
    if (!list) return;

    // Only immediate LIs in this layer
    const items = Array.from(list.children).filter(li =>
      li.tagName === 'LI' &&
      !li.classList.contains('mobile-menu__bottom') &&
      !li.classList.contains('mobile-menu__sub-menu--back')
    );
    if (!items.length) return;

    // Set per-item index (fallback if your inline --i isn’t present)
    items.forEach((li, i) => li.style.setProperty('--idx', i));

    // Retrigger the CSS animation cleanly
    list.classList.remove('mobile-menu__animating');
    // Force reflow so the class re-add restarts the keyframes
    void list.offsetWidth;
    list.classList.add('mobile-menu__animating');
  }

  const init = () => {
    // Open/close whole mobile menu
    menuButton.addEventListener("click", () => {
      const isOpening = !mobileMenu.classList.contains(activeOpenClass);

      if (isOpening) {
        // Opening: remove any leftover "close" classes
        mobileMenu
          .querySelectorAll(".mobile-menu__sub-menu--close")
          .forEach((el) => el.classList.remove("mobile-menu__sub-menu--close"));

        mobileMenu.classList.add(activeOpenClass);
        burgerMenu.classList.add(activeClass);
        runMenuStagger(mobileMenu.querySelector('.mobile-menu__main'));
      } else {
        // Closing: add "close" class to all submenus
        addCloseClassToAllSubmenus();

        mobileMenu.classList.remove(activeOpenClass);
        burgerMenu.classList.remove(activeClass);
        runMenuStagger(mobileMenu.querySelector('.mobile-menu__main'));
      }

      toggleBodyScroll();
    });

    // Event delegation for all submenu interactions
    mobileMenu.addEventListener("click", (e) => {
      const arrow = e.target.closest(".mobile-menu__main__link--parent--arrow");
      if (arrow) {
        // Open the submenu next to the arrow clicked
        const submenu = arrow.nextElementSibling;
        if (submenu && submenu.classList.contains("mobile-menu__sub-menu")) {
          showMenu(submenu);
          runMenuStagger(submenu);
        }
        return;
      }

      const backBtn = e.target.closest(".mobile-menu__sub-menu--back");
      if (backBtn) {
        const currentSubmenu = backBtn.closest(".mobile-menu__sub-menu");
        hideMenu(currentSubmenu);
        const parentSubmenu = currentSubmenu?.parentElement?.closest(".mobile-menu__sub-menu");
        if (parentSubmenu) {
          showMenu(parentSubmenu);
          runMenuStagger(parentSubmenu);
        }
      }
    });
  };

  init();
}
